/**
 * Extrai a mensagem legivel de um erro da API.
 *
 * Aceita tanto o erro do axios (e.response.data) quanto o corpo ja extraido
 * (mixins que fazem `throw e.response.data`). O campo `errors` pode vir como
 * string, array de { property, message } ou objeto de validacao do .NET.
 */
export function extrairMensagemErroApi(e, mensagemPadrao = 'Ocorreu um erro') {
  const data = e?.response?.data ?? e
  // Corpo HTML (ex.: 502/504 do gateway) nao e mensagem: cai na mensagem padrao.
  if (typeof data === 'string' && data && !data.trim().startsWith('<')) return data

  const errors = data?.errors
  if (Array.isArray(errors)) {
    const mensagens = errors
      .map(err => (err && err.message) || (typeof err === 'string' ? err : null))
      .filter(Boolean)
    if (mensagens.length) return mensagens.join('\n')
  } else if (errors && typeof errors === 'object') {
    const mensagens = Object.values(errors).flat().filter(Boolean)
    if (mensagens.length) return mensagens.join('\n')
  } else if (typeof errors === 'string' && errors) {
    return errors
  }
  return data?.message || e?.message || mensagemPadrao
}

export function isErroPedidoMedico(mensagem) {
  return typeof mensagem === 'string' && mensagem.toLowerCase().includes('pedido médico')
}
